module.exports = __webpack_public_path__ + "static/img/oldphone.63828a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oldphone.jpg
// module id = ppPn
// module chunks = 0